import React, { useEffect, useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import PasswordInfo from "./PasswordInfo";
import LocationInfo from "./LocationInfo";
import PersonalInfo from "./PersonalInfo";
// import { useDispatch, useSelector } from "react-redux";
import { useDispatch, useSelector } from "../../../../redux/store";
import { getProfile, updateProfile } from "../../../../redux/slices/user";

const Index = () => {
  const dispatch = useDispatch();
  // const { userDetail } = useSelector((state) => state.user);

  const [tabIndex, setTabIndex] = useState(0);
  // const [userData, setUserData] = useState({});

  // useEffect(() => {
  //   setUserData(userDetail);
  // }, [userDetail]);

  useEffect(() => {
    const storedRslId = sessionStorage.getItem("rslkeyId");

    let rslId = "";
    if (storedRslId && storedRslId !== "undefined" && storedRslId !== "null") {
      try {
        rslId = JSON.parse(storedRslId);
      } catch (error) {
        console.error("Error parsing rslId from sessionStorage:", error);
      }
    }

    dispatch(
      getProfile({
        rslId,
      })
    );
  }, []); // ✅ No unnecessary re-renders




  const tabs = [
    {
      label: "Personal Information",
      // content: <PersonalInfo userDetail={userDetail} />,
      content: <PersonalInfo />,
    },
    // {
    //   label: "Location Information",
    //   content: <LocationInfo />,
    // },
    // {
    //   label: "Change Password",
    //   content: <PasswordInfo />,
    // },
  ];



  return (
    <Tabs
      className="tabs -underline-3 js-tabs"
      selectedIndex={tabIndex}
      onSelect={(index) => setTabIndex(index)}
    >
      <TabList className="tabs__controls row x-gap-40 y-gap-10 lg:x-gap-20">
        {tabs.map((tab, index) => (
          <Tab key={index} className="col-auto">
            <button className="tabs__button text-18 lg:text-16 text-light-1 fw-500 pb-5 lg:pb-0 js-tabs-button">
              {tab.label}
            </button>
          </Tab>
        ))}
      </TabList>

      <div className="tabs__content pt-30 js-tabs-content">
        {tabs.map((tab, index) => (
          <TabPanel
            key={index}
            className={`-tab-item-${index + 1} ${tabIndex === index ? "is-tab-el-active" : ""
              }`}
          >
            {tab.content}
          </TabPanel>
        ))}
      </div>
    </Tabs>
  );
};

export default Index;
